import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class JurisdictionCommutableThreshold implements Deserializable {
  public governingJurisdictionId!: GoverningJurisdictionTypeId;
  public governingJurisdiction!: GoverningJurisdictionType | null;
  public balance!: number;
  public threshold!: number;

  public onDeserialize() {
    this.governingJurisdiction = this.governingJurisdiction
      ? window.injector.Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction)
      : null;
  }
}
